// @ts-nocheck


export const TableStyle = {
  Constrant: 'constrant',
  Regular: 'regular'
}